import {Component, OnInit, Input} from '@angular/core';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';

@Component({
  selector: 'app-company-select',
  templateUrl: './company-select.component.html',
  styleUrls: ['./company-select.component.css'],
  standalone: false
})
export class CompanySelectComponent implements OnInit {
  @Input() vm: any;

  constructor(public isFiltered: IsFilterOnService) {
  }

  ngOnInit() {
    // Initialize companyName if a company_id is already selected
    const selectedId = this.vm?.request?.company_id;
    if (selectedId != null && selectedId !== '') {
      this.onCompanyChange(selectedId);
    }
  }

  checkFiltered(): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    this.vm.filtered = filteredValue;
    return filteredValue;
  }

  // Ensure vm.companyName follows the selected company in the dropdown
  onCompanyChange(newCompanyId: any) {
    // preserve existing behaviour
    this.vm.report = [];
    this.checkFiltered();

    try {
      const idStr = String(newCompanyId ?? this.vm?.request?.company_id ?? '');
      const companies = Array.isArray(this.vm?.company) ? this.vm.company : [];
      const found = companies.find((c: any) => String(c?.id) === idStr);
      this.vm.companyName = found?.name || '';
    } catch (e) {
      // fallback to empty on any unexpected shape
      this.vm.companyName = '';
    }
  }
}
